import { useRef, useCallback } from 'react'
import { Modal } from 'antd'

import Signature from 'common/components/Signature/Signature'
import { Button } from 'common/components/Button/Button'

import styles from './signature-dialog.module.scss'

type Props = {
  isVisible: boolean
  onClose: () => void
  onSign: (signatureDataUrl: string) => void
  title?: string
  canvasWidth?: number
  canvasHeight?: number
}

export const SignatureDialog = ({
  isVisible,
  onClose,
  onSign,
  title = 'Draw Signature',
  canvasWidth = 440,
  canvasHeight = 200,
}: Props) => {
  const signatureRef = useRef<{ clear: () => void }>(null)
  const currentSignatureRef = useRef<string>('')

  const handleFinish = useCallback((signatureDataUrl: string) => {
    currentSignatureRef.current = signatureDataUrl
  }, [])

  const handleClear = useCallback(() => {
    signatureRef.current?.clear()
    currentSignatureRef.current = ''
  }, [])

  const handleSign = useCallback(() => {
    if (currentSignatureRef.current) {
      onSign(currentSignatureRef.current)
      onClose()
    }
  }, [onSign, onClose])

  return (
    <Modal
      open={isVisible}
      onCancel={onClose}
      title={title}
      destroyOnHidden
      footer={null}
      width={500}
      centered
      classNames={{ content: styles.modalContent }}>
      <div className={styles.container}>
        <div className={styles.canvasWrapper}>
          <Signature
            ref={signatureRef}
            width={canvasWidth}
            height={canvasHeight}
            onFinish={handleFinish}
          />
        </div>
        <div className={styles.actions}>
          <button type='button' className={styles.clearButton} onClick={handleClear}>
            Clear
          </button>
          <Button onClick={handleSign}>Sign</Button>
        </div>
      </div>
    </Modal>
  )
}
